import SlideManager from "../utils/slide-manager";
import getVWKey from "./getVWKey";

const activeRenderData = { lerping: false };

function setRenderData(data) {
    return Object.assign(activeRenderData, data);
}

function getRenderData(isMobile) {
    return activeRenderData && activeRenderData.lerping === true
        ? activeRenderData
        : isMobile
            ? getVWKey() === "sizeSm" && SlideManager.currentSlide.rendererSm
                ? SlideManager.currentSlide.rendererSm
                : { top: 0, left: 0, width: 1, height: 1 }
            : SlideManager.currentSlide.renderer;
}

export default getRenderData;
export { getRenderData, setRenderData };